
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'AdvancedDescriptions',
  props: {
    data: {
      type: Array as PropType<Array<{ title: string; key: string; isFull?: boolean; align?: string }>>,
      default: () => []
    },
    info: {
      type: Object as PropType<Record<string, any>>,
      default: () => ({})
    }
  }
})
